import { Typography } from "@mui/material";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

export const iconSx = { fontSize: 100 };

export type LeistungType = {
  title: string;
  beschreibung: string;
  icon: ReactNode;
  link: string;
};

export default function Leistung(props: { leistung: LeistungType }) {
  const navigate = useNavigate();
  return (
    <div
      className="leistung-wrap"
      onClick={() => navigate("/leistungen/" + props.leistung.link)}
    >
      <div className="leistung">
        {props.leistung.icon}
        <br />
        <Typography variant="h2" textAlign="center" fontSize={36}>
          {props.leistung.title}
        </Typography>
        <br />
        <Typography className="details" variant="body1" textAlign="center">
          {props.leistung.beschreibung}
        </Typography>
      </div>
    </div>
  );
}
